import Cycler from 'lib/Cycler/Cycler';
import { ITelemetryDataItem } from 'shared/entities/telemetry';
import { IRootStore } from 'shared/entities/store/rootStore';
import { apiUrls } from 'shared/entities/domain';

import { TelemetryDataItemModel } from './TelemetryDataItemModel';

const SEND_INTERVAL = 4000;

export class TelemetryModel {
  private queue: TelemetryDataItemModel[] = [];
  private cycler: Cycler;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    this.send = this.send.bind(this);

    this.cycler = new Cycler();
    this.cycler.init(this.send, SEND_INTERVAL);
  }

  add(item: ITelemetryDataItem): void {
    this.queue.push(new TelemetryDataItemModel(item));
  }

  private async send(): Promise<boolean> {
    if (
      this.queue.length === 0 ||
      !this.rootStore.userStore.isAuthorized ||
      this.rootStore.projectId === null
    ) {
      return true;
    }

    const queueToSend = [...this.queue];
    this.queue = [];

    const response = await this.rootStore.networkStore.api(
      apiUrls.TELEMETRY_SEND,
      {
        method: 'POST',
        data: {
          navigation: queueToSend.map((item) => item.toJson())
        }
      }
    );

    if (response.isError) {
      this.queue = [...queueToSend, ...this.queue];
      return false;
    }

    return true;
  }
}
